import { DatePipe, DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { MatList, MatListItem, MatListItemLine, MatListItemTitle } from '@angular/material/list';
import { AuthorizationService } from '@ng-cloud/badger-core';
import { take } from 'rxjs/operators';
import { CaptureEvent } from '../../models/capture-event';

@Component({
  selector: 'bt-capture-event-detail',
  templateUrl: './capture-event-detail.component.html',
  styleUrls: ['./capture-event-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DatePipe,
    DecimalPipe,
    MatList,
    MatListItem,
    MatListItemLine,
    MatListItemTitle,
    NgTemplateOutlet
  ]
})
export class CaptureEventDetailComponent implements OnInit {
  @ContentChild(TemplateRef) additionalDetailTemplate;
  @Input() captureEvent: CaptureEvent;

  hasAccess = false;

  constructor(protected authorizationService: AuthorizationService) {
  }

  ngOnInit() {
    this.authorizationService
      .accessToAny(['admin'])
      .pipe(take(1))
      .subscribe((hasAccess) => {
        this.hasAccess = hasAccess;
      });
  }
}
